import { AbstractCommand } from 'src/models/command';

class SetAutomaticUserStateCommand extends AbstractCommand {
	readonly name = 'IFS_UserState_Command_Commands_SetAutomaticUserState';

	public constructor(automaticUserStateId: number) {
		super();
		this.parameters = {
			apiKey: 'fcab2a0c-54b2-460d-9f6d-ee5ed64b585a',
			automaticUserStateId: automaticUserStateId,
		};
	}
}

class DeleteAutomaticUserStateCommand extends AbstractCommand {
	readonly name = 'IFS_UserState_Command_Commands_DeleteAutomaticUserState';

	public constructor(automaticUserStateId: number | undefined) {
		super();
		this.parameters = {
			apiKey: 'fcab2a0c-54b2-460d-9f6d-ee5ed64b585a',
			automaticUserStateId: automaticUserStateId,
		};
	}
}

export { DeleteAutomaticUserStateCommand, SetAutomaticUserStateCommand };
